import { transaction } from "@/stores/transaction";
import { useUserStore } from "@/stores/user";


export default function initTransaction({ next, router }) {
    const Transaction = transaction();
    const permissions = useUserStore();
    const user = JSON.parse(localStorage.getItem("user"))?.appUser ||{};
    Transaction.fetchGoldPrices;
    Transaction.fetchGoldCodeTable;
    Transaction.fetchExchangeRate;
    Transaction.fetchGoldPriceBAC;
    Transaction.fetchGoldPriceVT;
    Transaction.fetchPriceCode;
    permissions.getUser(user);
    Transaction.REMOVE_TRANSACTION(0,0,1)

    return next();
  }